import { Suspense, lazy, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { FullLoader } from '@libComponents';

import { isAuthenticatedSelector } from './redux.selectors';
import { setAuthData } from './redux.actions';
import { handleMsalRedirect } from './msalClient';
import { completeMicrosoftLogin } from './completeMicrosoftLogin';

const PublicContainer = lazy(() => import('./PublicContainer'));
const PrivateContainer = lazy(() => import('../navigation'));

export default () => {
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const dispatch = useDispatch();

    // Complete a Microsoft sign-in that used the full-page redirect flow (mobile / popup
    // blocked). On load, MSAL surfaces the id_token; exchange it for app tokens and log in.
    useEffect(() => {
        let active = true;
        handleMsalRedirect().then(async (idToken) => {
            if (!idToken || !active) return;
            try {
                const parsedAuthData = await completeMicrosoftLogin(idToken);
                if (active) dispatch(setAuthData(parsedAuthData));
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Microsoft redirect sign-in failed', e);
            }
        });
        return () => { active = false; };
    }, [dispatch]);

    return (
        <Suspense fallback={<FullLoader />}>
            {isAuthenticated ? <PrivateContainer /> : <PublicContainer />}
        </Suspense>
    );
};
